module.exports = __webpack_public_path__ + "img/css.67ae6ca1.png";